import {
  requestGet,
  requestPost,
  requestPut,
  requestDelete,
  api,
} from "../config/Api";
import { downloadFilePost } from "./ReportService";

const base = "individual-liquidations";

// ── Liquidaciones ─────────────────────────────────────────────────────────────

export const getAllIndividualLiquidations = (params) => requestGet(base, params);

export const getIndividualLiquidationsByLegalFile = (legalFileId) =>
  requestGet(`${base}/legal-file/${legalFileId}`);

export const getAvailableRubros = (legalFileId, params) =>
  requestGet(`${base}/legal-file/${legalFileId}/available-rubros`, params);

export const previewIndividualLiquidation = (legalFileId, data) =>
  requestPost(`${base}/legal-file/${legalFileId}/preview`, data);

// HTML de la planilla sin guardar nada — para revisar el PDF antes de generarlo.
export const previewIndividualLiquidationPdf = (legalFileId, data) =>
  requestPost(`${base}/legal-file/${legalFileId}/preview-pdf`, data);

export const storeIndividualLiquidation = (legalFileId, data) =>
  requestPost(`${base}/legal-file/${legalFileId}`, data);

export const getIndividualLiquidation = (id) => requestGet(`${base}/${id}`);

export const updateIndividualLiquidation = (id, data) =>
  requestPut(`${base}/${id}`, data);

export const deleteIndividualLiquidation = (id) =>
  requestDelete(`${base}/${id}`);

export const generateIndividualLiquidationPdf = (id) =>
  requestPost(`${base}/${id}/generate-pdf`, {});

export const previewIndividualLiquidationHtml = async (id) => {
  const response = await api.get(`${base}/${id}/preview-html`, { responseType: "text" });
  return response.data;
};

export const exportIndividualLiquidationSheet = (payload) =>
  downloadFilePost(`${base}/report/sheet`, payload);

// ── Catálogo: tipos de rubros ────────────────────────────────────────────────

export const getIndividualItemTypes = (params) =>
  requestGet(`${base}/catalog/item-types`, params);
export const createIndividualItemType = (data) =>
  requestPost(`${base}/catalog/item-types`, data);
export const updateIndividualItemType = (id, data) =>
  requestPut(`${base}/catalog/item-types/${id}`, data);
export const deleteIndividualItemType = (id) =>
  requestDelete(`${base}/catalog/item-types/${id}`);

// ── Catálogo: juzgados ──────────────────────────────────────────────────────

export const getIndividualDependenciesConfig = (params) =>
  requestGet(`${base}/catalog/dependencies`, params);
export const createIndividualDependency = (data) =>
  requestPost(`${base}/catalog/dependencies`, data);
export const getIndividualDependencyItemTypes = (depId) =>
  requestGet(`${base}/catalog/dependencies/${depId}/item-types`);
export const syncIndividualDependencyItemTypes = (depId, data) =>
  requestPut(`${base}/catalog/dependencies/${depId}/item-types`, data);

// ── Catálogo: tasas de interés judiciales ───────────────────────────────────

export const getJudicialInterestRates = (params) =>
  requestGet(`${base}/catalog/interest-rates`, params);
export const createJudicialInterestRate = (data) =>
  requestPost(`${base}/catalog/interest-rates`, data);
export const updateJudicialInterestRate = (id, data) =>
  requestPut(`${base}/catalog/interest-rates/${id}`, data);
export const deleteJudicialInterestRate = (id) =>
  requestDelete(`${base}/catalog/interest-rates/${id}`);
export const importJudicialInterestRatesBcra = (data) =>
  requestPost(`${base}/catalog/interest-rates/import`, data);

// Últimos 5 valores de cada serie — para el visualizador del formulario.
export const getJudicialInterestRatesLatest = () =>
  requestGet(`${base}/interest-rates/latest`);

// ── Catálogo: montos propios (Caja de Abogados / Colegio) — type = individual ─
export const getIndividualBarAssocValues = (params) =>
  requestGet(`${base}/catalog/bar-assoc`, params);
export const createIndividualBarAssocValue = (data) =>
  requestPost(`${base}/catalog/bar-assoc`, data);
export const updateIndividualBarAssocValue = (id, data) =>
  requestPut(`${base}/catalog/bar-assoc/${id}`, data);
export const deleteIndividualBarAssocValue = (id) =>
  requestDelete(`${base}/catalog/bar-assoc/${id}`);

export const getIndividualBarCollegeFees = (params) =>
  requestGet(`${base}/catalog/bar-college`, params);
export const createIndividualBarCollegeFee = (data) =>
  requestPost(`${base}/catalog/bar-college`, data);
export const updateIndividualBarCollegeFee = (id, data) =>
  requestPut(`${base}/catalog/bar-college/${id}`, data);
export const deleteIndividualBarCollegeFee = (id) =>
  requestDelete(`${base}/catalog/bar-college/${id}`);

// ── Comprobantes de tasa (portal judicial) ─────────────────────────────────
export const getTaxReceipts = (legalFileId) =>
  requestGet(`${base}/legal-file/${legalFileId}/tax-receipts`);
export const syncTaxReceipts = (legalFileId) =>
  requestPost(`${base}/legal-file/${legalFileId}/tax-receipts/sync`, {});
export const getTaxReceiptDetail = (legalFileId, receiptId) =>
  requestGet(`${base}/legal-file/${legalFileId}/tax-receipts/${receiptId}`);

// ── Planilla de liquidación del portal judicial ────────────────────────────
export const getLiquidationSheet = (legalFileId) =>
  requestGet(`${base}/legal-file/${legalFileId}/liquidation-sheet`);
export const syncLiquidationSheet = (legalFileId) =>
  requestPost(`${base}/legal-file/${legalFileId}/liquidation-sheet/sync`, {});

// ── Borrador compartido (reemplaza el que vivía en localStorage) ───────────
export const getIndividualLiquidationDraft = (legalFileId, editingLiquidationId) =>
  requestGet(`${base}/legal-file/${legalFileId}/draft`, {
    editing_liquidation_id: editingLiquidationId ?? undefined,
  });
export const saveIndividualLiquidationDraft = (legalFileId, data) =>
  requestPut(`${base}/legal-file/${legalFileId}/draft`, data);
export const deleteIndividualLiquidationDraft = (legalFileId, editingLiquidationId) =>
  requestDelete(`${base}/legal-file/${legalFileId}/draft`, {
    editing_liquidation_id: editingLiquidationId ?? undefined,
  });
